import ChartConnector from './containers/ChartConnector';

export default ChartConnector;
